export default __webpack_public_path__ + "static/nimbus-72eb4e0cff09cfd6483fe4b2bba29a27.ttf";